module.exports = __webpack_public_path__ + "img/astra-lite.1c13aabc.png";